// Node
import $ from 'jquery';
import { isEqual } from 'lodash';
import { isMobileDevice, sortForMap } from '../filter_utils';
import { getBalloonPosition } from '../new_design/common/map/balloon_utils';
import { localizeRulerControls } from '../new_design/common/map/ruler_utils';
import { CloseBlackIcon, LoaderCircleIcon } from '../shared/jsx_icons';
import Map from './map.js';
import MapCampCard from './map_camp_card.js';

export default class MapDesktop extends Map {
  constructor(props) {
    super(props);
    this.campCardHeight = 150;
    this.initMarkerEventListeners = this.initMarkerEventListeners.bind(this);
    this.generateManagerLayout = this.generateManagerLayout.bind(this);
    this.state = {
      balloonCamp: null,
      balloonX: 0,
      balloonY: 0,
      mouseOnBalloon: false,
      mouseOnMarker: false,
      loadingYScript: true,
      balloonVisible: false,
    };
    this.campsToShowCount = 50;
    this.hoverTimeout = null;
    this.rulerEditable = false;
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.filters !== this.props.filters ||
      prevProps.s_params?.date_start !== this.props.s_params?.date_start ||
      prevProps.s_params?.date_end !== this.props.s_params?.date_end ||
      prevProps.s_params?.with_pet !== this.props.s_params?.with_pet ||
      prevProps.s_params?.count_guests !== this.props.s_params?.count_guests ||
      !isEqual(prevProps.s_params?.children_ages.sort(), this.props.s_params?.children_ages.sort())
    ) {
      this.setState({ loadingCamps: true });
      if (window.loadCampsMapTimeout) {
        clearTimeout(window.loadCampsMapTimeout);
      }
      this.abortController?.abort();
      window.loadCampsMapTimeout = setTimeout(() => {
        this.setState(
          {
            allCamps: [],
            camps: [],
            calculated_camps_ids: [],
          },
          () => {
            this.loadCamps(this.state.mapMoved);
          }
        );
      }, 1000);
    }
  }

  handleMapClick() {
    this.setState({ balloonCamp: null });
    this.refreshMap();
  }

  handleClose() {
    if (window.location.hash.includes('#map_opened') && !this.props.preventHistoryBack) {
      history.back();
    }
    this.props.showList();
  }

  handlePopstate() {
    if (!window.location.hash.includes('#map_opened')) {
      this.props.showList();
    }
  }

  async _initMap() {
    await ymaps3.ready;

    if (!ymaps3._defaultUiThemeRegistered) {
      ymaps3.import.registerCdn('https://cdn.jsdelivr.net/npm/{package}', ['@yandex/ymaps3-default-ui-theme@0.0.24']);
      ymaps3._defaultUiThemeRegistered = true;
    }

    const { YMapZoomControl } = await ymaps3.import('@yandex/ymaps3-default-ui-theme');

    const { YMapDefaultRuler } = await ymaps3.import('@yandex/ymaps3-default-ui-theme');
    this.YMapDefaultRuler = YMapDefaultRuler;

    await this.createMap(this.props.mapOptions);
    this.markers = [];
    this.markerIds = [];
    this.mouseOnMarker = false;
    this.hoverTimeout = null;
    this.mapCanvas = $('ymaps3').first();
    this.isMobile = isMobileDevice();

    if (this.props.mapOptions.fullScreen) {
      this.controls = new ymaps3.YMapControls({
        position: 'top right',
        orientation: 'horizontal',
      });

      this.fullscreenButton = new ymaps3.YMapControlButton({
        text: 'Назад к списку',
        onClick: () => this.handleClose(),
      });

      this.rulerButton = new ymaps3.YMapControlButton({
        text: 'Линейка',
        onClick: () => this.toggleRuler(),
      });

      this.controls.addChild(this.rulerButton);
      this.controls.addChild(this.fullscreenButton);
      this.map.addChild(this.controls);
    }

    this.zoomControls = new ymaps3.YMapControls({
      position: 'right',
      orientation: 'vertical',
    });

    this.zoomControls.addChild(new YMapZoomControl());
    this.map.addChild(this.zoomControls);

    this.ruler = new this.YMapDefaultRuler({
      type: 'ruler',
      editable: this.rulerEditable,
      points: [],
    });

    this.map.addChild(this.ruler);

    localizeRulerControls();

    this.setState(
      {
        allCamps: this.props.allCamps || [],
        camps: this.props.allCamps || [],
        calculated_camps_ids: (this.props.allCamps || []).map((c) => c.id),
        loadingYScript: false,
      },
      () => {
        const campsInBorders = this.filterCampsInBorder(this.state.camps);

        this.setState(
          {
            campsInBorders,
          },
          () => {
            this.initMarkers(campsInBorders);
            this.refreshMap();
          }
        );

        if (this.props.showManagerMap) {
          let sorted = sortForMap(this.state.allCamps, null);

          this.setState({ allCamps: sorted });
        }
        // Отобразить на карте все базы региона и 60 соседних
        this.loadCamps();
        this.initMapEventListeners();

        // Если выбрано расположение ОР на карте, центруем карту по ОР
        let props_sight = this.props.sight;
        if (props_sight) {
          this.map.update({
            location: {
              center: [props_sight.coordinates[0].longitude, props_sight.coordinates[0].latitude],
              zoom: this.campActivatedZoom,
              duration: 200,
              easing: 'ease-in-out',
            },
          });
        } else if (this.props.camp) {
          this.map.update({
            location: {
              center: [this.props.camp.longitude, this.props.camp.latitude],
              zoom: this.campActivatedZoom,
              duration: 200,
              easing: 'ease-in-out',
            },
          });
        }
      }
    );

    window.addEventListener('popstate', (e) => {
      this.handlePopstate();
    });
  }

  paintCanvasMarker(marker) {
    const camp = this.state.allCamps.find((camp) => camp.id == marker._campId);
    if (!camp) return;

    this.setState({ balloonCamp: camp, mouseOnMarker: true, balloonVisible: false }, () => {
      requestAnimationFrame(() => {
        const markerEl =
          marker.element.querySelector('.placemark_layout_container') ||
          marker.element.querySelector('.manager-placemark_layout');
        const balloonEl = document.querySelector('.card_map');
        if (!markerEl || !balloonEl) return;

        const pos = getBalloonPosition(markerEl, balloonEl);

        this.setState(
          {
            balloonX: pos.x,
            balloonY: pos.y,
            balloonVisible: true,
          },
          () => {
            this.attachBalloonEventListeners(marker);
            this.refreshMap();
          }
        );
      });
    });
  }

  attachBalloonEventListeners(marker) {
    const balloonElement = $('.card_map');
    if (balloonElement.length) {
      balloonElement.on(
        'mouseenter',
        function () {
          this.setState({ mouseOnBalloon: true });
        }.bind(this)
      );
      balloonElement.on(
        'mouseleave',
        function () {
          this.setState({ mouseOnBalloon: false }, () => {
            this.initiateCloseBalloon(marker);
          });
        }.bind(this)
      );
    }
  }

  initMapEventListeners() {
    const mapListener = new ymaps3.YMapListener({
      layer: 'any',
      onActionEnd: async () => {
        const campsInBorders = this.filterCampsInBorder(this.state.camps);
        this.setState({ loadingCamps: false, campsInBorders: campsInBorders, mapMoved: true });
        this.initMarkers(campsInBorders);
        this.initMarkers(this.filterCampsInBorder(this.state.camps));
        this.refreshMap();
        if (window.loadCampsMapTimeout) {
          clearTimeout(window.loadCampsMapTimeout);
        }
        this.abortController?.abort();
        window.loadCampsMapTimeout = setTimeout(() => {
          this.loadCamps(true);
        }, 1000);
      },
      onClick: () => {
        if (!this.rulerEditable) {
          this.handleMapClick();
        }
      },
    });

    this.map.addChild(mapListener);
  }

  initMarkerEventListeners(delay = 0) {
    if (this.markerListener) return;

    this.markerListener = new ymaps3.YMapListener({
      layer: 'any',
      onMouseEnter: (event) => {
        const entity = event?.entity;
        if (!entity || !(entity instanceof this.YMapMarker)) return;
        this.currentMarker = entity;
        clearTimeout(this.hoverTimeout);
        this.setState({ mouseOnMarker: true });
        this.openBalloon(entity, delay);
      },
      onMouseLeave: (event) => {
        const entity = event?.entity;
        if ((!entity || !(entity instanceof this.YMapMarker)) && !this.currentMarker) return;
        this.setState({ mouseOnMarker: false }, () => {
          this.initiateCloseBalloon(entity || this.currentMarker);
          this.currentMarker = null;
        });
      },
      onFastClick: (event) => {
        const entity = event?.entity;
        if (!(entity instanceof this.YMapMarker)) return;
        if (entity._url) {
          window.open(entity._url, '_blank');
        }
      },
    });

    this.map.addChild(this.markerListener);
  }

  closeBalloon(marker) {
    this.setState({ balloonCamp: null, mouseOnMarker: false }, () => {
      if (marker._camp) {
        this.refreshMap([marker]);
      }
    });
  }

  initiateCloseBalloon(marker) {
    if (!this.state.mouseOnMarker) {
      this.closeBalloon(marker);
    }
  }

  render() {
    const {
      state: { balloonCamp, balloonVisible, balloonX, balloonY, loadingYScript, loadingCamps },
      props: { favorites, toggleFavoriteCamp, totalGuestsCount },
    } = this;

    return (
      <div>
        <div
          id='map-canvas'
          ref={this.mapCanvasRef}
          className='cards-map'
          style={{
            display: 'block',
            position: 'fixed',
            left: 0,
            top: 0,
            height: $(window).height(),
            width: '100vw',
            margin: '0',
            background: 'white',
          }}
        >
          {(loadingYScript || loadingCamps) && (
            <div className={'map-circle-loader-wrapper'}>
              <LoaderCircleIcon />
            </div>
          )}
          {loadingYScript && (
            <a className={'cards-map__close-btn'} onClick={this.handleClose}>
              <CloseBlackIcon className={'cards-map__close-black-icon'} />
            </a>
          )}

          {balloonCamp ? (
            <div
              id='customInfoWindow'
              style={{
                visibility: balloonVisible ? 'visible' : 'hidden',
                opacity: balloonVisible ? 1 : 0,
                pointerEvents: balloonVisible ? 'auto' : 'none',
                position: 'fixed',
                left: balloonX,
                top: balloonY,
                zIndex: 10001,
              }}
            >
              <MapCampCard
                item={balloonCamp}
                isFavorite={favorites.includes(balloonCamp.id)}
                toggleFavoriteCamp={toggleFavoriteCamp}
                totalGuestsCount={balloonCamp.total_guests_count ?? totalGuestsCount}
              />
            </div>
          ) : (
            ''
          )}
        </div>
      </div>
    );
  }

  instantBookingIcon(item) {
    if (item.is_can_instant_booking) {
      return `<div class='icon icon-flash_blue icon-flash_blue-dims'></div>`;
    }
    return '';
  }

  generateManagerLayout(item, zIndex, suitable = false, selected = false) {
    if (item == null) return '';
    let classes = '';
    if (selected) classes += ' selected';

    const from_region_without_prices = !item.camp_loaded_from_filter_list && item.region_id == this.props.region_id;

    if (item.can_be_booked && !from_region_without_prices) {
      if (parseInt(item.books_count) === 0) classes += ' brown';
      else if (parseInt(item.books_count) === 1) classes += ' brown-green';
      else if (parseInt(item.books_count) <= 4) classes += ' green-brown';
      else classes += ' green';

      if (suitable) classes += ' suitable';
    } else {
      if (parseInt(item.books_count) === 0) classes += ' light-gray';
      else if (parseInt(item.books_count) <= 4) classes += ' gray';
      else classes += ' dark-gray';
    }
    return `<div class="manager-placemark_layout_container ">
         <div class="manager-placemark_layout${classes}">
           ${this.instantBookingIcon(item)}
           ${item.contract_percent ?? '0'}
         </div>
       </div>`;
  }

  async createMap(options) {
    const { YMap, YMapDefaultSchemeLayer, YMapDefaultFeaturesLayer, YMapMarker } = ymaps3;

    this.YMapMarker = YMapMarker;

    const bounds = options.bbox;

    let offsetLon;
    let location;

    if (options.bbox?.length) {
      const rect = this.mapCanvasRef.current.getBoundingClientRect();
      const lonSpan = bounds[1][0] - bounds[0][0];
      offsetLon = (lonSpan / rect.width) * 280;
      location = {
        bounds: [
          [bounds[0][1], bounds[0][0] - offsetLon],
          [bounds[1][1], bounds[1][0]],
        ],
      };
    } else {
      location = {
        center: [this.props.longitude, this.props.latitude],
        zoom: options.zoom ?? 10,
      };
    }

    const margin = options.bbox?.length ? [10, 10, 10, 10] : [0, 0, 0, 0];
    const zoomRange = options.bbox?.length ? { min: 5, max: 19 } : { min: 0, max: 21 };

    this.map = new YMap(this.mapCanvasRef.current, {
      location,
      margin,
      zoomRange,
    });

    this.map.addChild(new YMapDefaultSchemeLayer()).addChild(new YMapDefaultFeaturesLayer());

    const props_sight = this.props.sight;
    if (props_sight) {
      const coords = [props_sight.coordinates[0].longitude, props_sight.coordinates[0].latitude];

      const placemark = new YMapMarker({ coordinates: coords }, document.createElement('div'));

      this.map.addChild(placemark);
    }

    window.filter_map = this.map;
  }

  toggleRuler() {
    this.rulerEditable = !this.rulerEditable;

    this.ruler.update({
      editable: this.rulerEditable,
      points: [],
    });

    this.rulerButton.update({
      color: this.rulerEditable ? '#196dff' : '#222222',
    });
  }
}
